import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { NofeshPnimCanActivateGuard } from "../shared/guards/nofesh-pnim-can-activate.guard";
import { NofeshChulDetailsComponent } from "../nofshonim-chul/nofshon-chul-details/nofshon-chul-details.component";
import { OrderNofeshChulComponent } from "../nofshonim-chul/order/order-nofshon-chul.component";
import { nofshonimChulHomeComponent } from "../nofshonim-chul/home/nofshonim-chul-home.component";
import { MishpachotChulCanActivateGuard } from "../shared/guards/mishpachot-chul-can-activate.guard";
import { PirteyNofshimComponent } from "../nofshonim-chul/pirtey-nofshim/pirtey-nofshim.component";
import { PirteyTashlumComponent } from "../nofshonim-chul/pirtey-tashlum/pirtey-tashlum.component";
import { NofshonChulEndRishumComponent } from "../nofshonim-chul/nofshon-chul-end-rishum/end-rishum.component";
import { NofshonUploadsComponent } from "../nofshonim-chul/nofshon-chul-uploads/nofshon-chul-uploads.component";
import { CanActivateViaOAuthGuard } from "../oAuth.canActivateGuard";


const routes: Routes = [
    {
        path: "nofesh-pnim", 
        component: nofshonimChulHomeComponent, 
        canActivate: [ CanActivateViaOAuthGuard, NofeshPnimCanActivateGuard ], 
        children: [
            { 
                path: 'nofesh-details/:id', 
                component: NofeshChulDetailsComponent
            },
            { 
                path: 'order/:id', 
                component: OrderNofeshChulComponent
            }, 
            { 
                path: 'pirtey-nofshim/:id', 
                component: PirteyNofshimComponent 
            }, 
            { 
                path: 'pirtey-tashlum/:id', 
                component: PirteyTashlumComponent
            },
            { 
                path: 'uploads/:id', 
                component:NofshonUploadsComponent 
            },
            { 
                path: 'end-rishum', 
                component: NofshonChulEndRishumComponent
            }
        ]
    }
];


@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class NofeshPnimRouting{}
